import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-add-new-button',
  templateUrl: './add-new-button.component.html',
  styleUrls: ['./add-new-button.component.scss']
})
export class AddNewButtonComponent implements OnInit {

  @Input() label: string='';
  @Output() buttonClicked = new EventEmitter();
  
  constructor() { }

  ngOnInit(): void {
  }

  onAddNewButtonClicked(){
    this.buttonClicked.emit();
  }
}
